import { useEffect, useState } from "react";
import { Check, Flag, RotateCcw } from "lucide-react";
import { api, errorMessage } from "../lib/api";
import { formatDate } from "../constants/rox";

export const AdminReports = () => {
  const [reports, setReports] = useState(null);
  const [error, setError] = useState("");

  const load = () => { api.get("/admin/reports").then((r) => setReports(r.data)).catch((e) => setError(errorMessage(e))); };
  useEffect(load, []);

  const toggle = async (r) => {
    setError("");
    try {
      await api.post(`/admin/reports/${r.id}/resolve`);
      load();
    } catch (err) {
      setError(errorMessage(err));
    }
  };

  const open = reports?.filter((r) => r.status === "open").length || 0;
  return (
    <section className="mt-10" data-testid="admin-reports">
      <h2 className="h-display text-3xl">Signalements <span className="text-rox-orange">{open > 0 ? `· ${open}` : ""}</span></h2>
      <p className="mt-2 text-sm text-rox-off/75">Profils signalés par les athlètes. Marque un signalement comme traité une fois vérifié.</p>
      {error && <p data-testid="admin-reports-error" className="mt-3 text-sm text-rox-orange">{error}</p>}
      <div className="mt-4 space-y-2" data-testid="admin-reports-list">
        {reports?.length === 0 && <p data-testid="admin-reports-empty" className="panel p-4 text-sm text-rox-muted">Aucun signalement.</p>}
        {reports?.map((r) => (
          <div key={r.id} data-testid={`admin-report-${r.id}`} className={`panel flex items-start gap-3 p-3 ${r.status === "resolved" ? "opacity-50" : ""}`}>
            <Flag size={16} className="mt-1 shrink-0 text-rox-orange" />
            <div className="min-w-0 flex-1">
              <p className="h-display text-xl">{r.profile_name}</p>
              <p className="text-xs text-rox-off/80">{r.reason_label}{r.details ? ` · « ${r.details} »` : ""}</p>
              <p className="mt-1 text-[11px] text-rox-muted">Par {r.reporter_email} · {formatDate(r.created_at.slice(0, 10))}{r.profile_email ? ` · ${r.profile_email}` : ""}</p>
            </div>
            <button data-testid={`admin-report-toggle-${r.id}`} onClick={() => toggle(r)} className="flex h-9 w-9 shrink-0 items-center justify-center rounded-[3px] border border-rox-line text-rox-off/80 hover:border-rox-orange hover:text-rox-orange" aria-label={r.status === "resolved" ? "Réouvrir" : "Marquer comme traité"}>
              {r.status === "resolved" ? <RotateCcw size={15} /> : <Check size={15} />}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};
